// trigger build
function debug(resource: string): string | null {
  try {
    return sessionStorage.getItem(`CHILI_DEBUG_${resource}`)
  } catch (err) {
    return null
  }
}

function getEnv(env: any, defaultValue: any) {
  if (env !== undefined) {
    return env
  }
  return defaultValue
}

function hostHasChilipiper() {
  const hosts = ['chilipiper.io', 'chilipiper.com', 'na.chilipiper.com', 'chilipiper.cool']
  return hosts.some(host => {
    return window.location.host.includes(host)
  })
}

const getApiUrl = () => {
  const isDevOrIsTest = () =>
    ['test', 'development'].includes(process.env.NODE_ENV || '') ||
    process.env.DEPLOY_ENV === 'development'
  const isSSR = () => typeof window === 'undefined'
  // We need cookie session to be stored and reverse proxy doesn't store it
  if (isDevOrIsTest() || isSSR() || !hostHasChilipiper()) {
    return debug('API_RESOURCE') || process.env.REACT_APP_API_RESOURCE || ''
  }
  return `${debug('API_RESOURCE') || ''}/api`
}

export const endpoint = {
  auth: (): string => debug('AUTH_RESOURCE') || process.env.REACT_APP_AUTH_RESOURCE || '',
  x: (): string => debug('X_RESOURCE') || process.env.REACT_APP_X_RESOURCE || '',
  api: getApiUrl,
  apiRoot: () => debug('API_RESOURCE') || process.env.REACT_APP_API_RESOURCE || '',
  reporting: (): string =>
    debug('REPORTING_API_RESOURCE') || process.env.REACT_APP_REPORTING_API_RESOURCE || '',
  inbox: (): string =>
    debug('INBOX_API_RESOURCE') || process.env.REACT_APP_INBOX_API_RESOURCE || '',
  edge: (): string => debug('EDGE_RESOURCE') || process.env.REACT_APP_EDGE_RESOURCE || '',
  homebase: (): string =>
    debug('HOMEBASE_RESOURCE') || process.env.REACT_APP_HOMEBASE_RESOURCE || '',
  newInstantBooker: (): string =>
    debug('NEW_IB_RESOURCE') || `${process.env.REACT_APP_NEW_IB_RESOURCE}` || '',
  qa: (): string => debug('QA_RESOURCE') || process.env.REACT_APP_QA_RESOURCE || '',
  profiles: (): string =>
    debug('PROFILES_RESOURCE') || process.env.REACT_APP_PROFILES_RESOURCE || '',
  profilesUpload: (): string =>
    debug('PROFILES_UPLOAD_RESOURCE') || process.env.REACT_APP_PROFILES_UPLOAD_RESOURCE || '',
  addIn: (): string => debug('ADD_IN_RESOURCE') || process.env.REACT_APP_ADD_IN_RESOURCE || '',
  ib: (): string => debug('IB_RESOURCE') || process.env.REACT_APP_IB_RESOURCE || '',
  app: (): string => debug('CHILIPIPER_APP') || process.env.REACT_APP_CHILIPIPER_APP || '',
  inboxFE: (): string => debug('INBOX_FE') || process.env.REACT_APP_INBOX_RESOURCE || '',
  track: (): string => debug('TRACK_RESOURCE') || process.env.REACT_APP_TRACK_RESOURCE || '',
  backoffice: (): string => debug('BACKOFFICE') || process.env.REACT_APP_BACKOFFICE_RESOURCE || '',
}

export const secrets = {
  extensionId: process.env.REACT_APP_EXTENSION_ID_RESOURCE || '',
  intercom: process.env.REACT_APP_INTERCOM_RESOURCE || '',
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
  rolloutApiKey: process.env.REACT_APP_ROLLOUT_KEY || '',
  mixpanelChilinboxApiKey: process.env.REACT_APP_MIXPANEL_CHILINBOX_TOKEN || '',
  mixpanelConciergeApiKey: process.env.REACT_APP_MIXPANEL_CONCIERGE_TOKEN || '',
  cannyAppId: process.env.REACT_APP_CANNY_APP_ID || '',
  mixpanelConciergeOnboardingApiKey:
    process.env.REACT_APP_MIXPANEL_CONCIERGE_ONBOARDING_TOKEN || '',
  codoxChilicalApiKey: process.env.REACT_APP_CODOX_CHILICAL_KEY || '',
  percyIO: process.env.PERCY_TOKEN,
  fullstoryOrg: process.env.REACT_APP_FULLSTORY_ORG || '',
}

export const sentry = {
  env: process.env.REACT_APP_SENTRY_ENVIRONMENT || '',
  homebaseDSN: process.env.REACT_APP_SENTRY_HOMEBASE_DSN || '',
  bookingAppDSN: process.env.REACT_APP_SENTRY_BOOKING_APP_DSN || '',
  extensionDSN: process.env.REACT_APP_SENTRY_EXTENSION_DSN || '',
  instantBookerDSN: process.env.REACT_APP_SENTRY_INSTANTBOOKER_DSN || '',
  release: process.env.SENTRY_RELEASE_COMMIT || process.env.REACT_APP_SENTRY_RELEASE_COMMIT || '',
}

export const debugging = {
  tld: process.env.REACT_APP_REALTIME_URL_TLD || '',
  showStackTrace: getEnv(parseInt(process.env.REACT_APP_SHOW_STACK_TRACE as string), false),
}

export const marketing = {
  script: process.env.REACT_APP_MARKETING_SCRIPT || '',
}

export const thirdPartyServices = {
  useMixpanel: getEnv(parseInt(process.env.REACT_APP_ENABLE_MIX_PANEL as string), true),
}

export const webpack = {
  enableDLL: getEnv(
    parseInt(
      (process.env.ENABLE_WEBPACK_DLL || process.env.REACT_APP_ENABLE_WEBPACK_DLL) as string
    ),
    true
  ),
}

export const testing = {
  sessionId: process.env.REACT_APP_TEST_CHILI_SESSION_ID as string,
}

export const environment = {
  deploy: (process.env.DEPLOY_ENV || process.env.REACT_APP_DEPLOY_ENV) as string,
  node: process.env.NODE_ENV as string,
}
